export default "assets/images/6e1f2f2f6fed3c5cddeb925e7ae75aba.png";